import { PAYONEER_STORE_KEY } from "../store/index";
import { select } from '@wordpress/data';
import { isPayForOrder } from "./woocommerce";
import { defaultHooks } from "@wordpress/hooks";

const FORCE_HOSTED_MODE_HEADER = 'x-payoneer-checkout-force-hosted-flow'
const LIST_LONG_ID = 'x-payoneer-long-id'
const IS_PAYMENT_CHECKOUT = 'x-payoneer-is-payment-checkout'

const paymentCheckoutHeaderValue = () => {
	if ( !isPayForOrder ) {
		return '' // to avoid receiving random variables from non-payment pages
	}
	const urlParams = new URLSearchParams( window.location.search );
	return urlParams.get( 'key' ) || '';
};

const getCustomHeaders = () => {
	const customHeaders = {
		[ FORCE_HOSTED_MODE_HEADER ]: String( select( PAYONEER_STORE_KEY ).isHostedModeForced() ),
		[ IS_PAYMENT_CHECKOUT ]: paymentCheckoutHeaderValue()
	};
	return defaultHooks.applyFilters( 'payoneer.http.customHeaders', customHeaders );
};

/**
 * Since we need the getLongId resolver to have run once, we defer adding the header
 */
defaultHooks.addAction(
	'payoneer.checkout.onReceiveExtensionData',
	'payoneer/setupCustomHttpHeaders',
	() => {
		defaultHooks.addFilter(
			'payoneer.http.customHeaders',
			'payoneer/setupCustomHttpHeaders',
			function ( headers ) {
				headers[ LIST_LONG_ID ] = String( select( PAYONEER_STORE_KEY ).getLongId() )
				return headers;
			}
		)
	} );

/**
 * We decorate the global fetch function so that we can pass custom headers for outgoing requests.
 * This is used to control the hosted mode fallback in the back-end and for validating
 * that the frontend LIST longId matches the one used by the backend
 */
export const setupCustomHttpHeaders = async () => {

	const originalFetch = window.fetch;

	window.fetch = async ( ...args ) => {
		let [ url, options ] = args;
		// Only process requests going out to the same origin
		if ( new URL( url, window.location.origin ).origin !== window.location.origin ) {
			return originalFetch( url, options );
		}
		const customHeaders = getCustomHeaders();
		console.log( 'Adding custom headers to fetch call', customHeaders );
		// Clone the original options to avoid mutating it
		if ( options && options.headers ) {
			options = { ...options, headers: { ...options.headers, ...customHeaders } };
		} else {
			options = { ...options, headers: customHeaders };
		}

		return await originalFetch( url, options );
	};

	if ( !window.XMLHttpRequest ) {
		return;
	}

	const originalOpen = XMLHttpRequest.prototype.open;
	const originalSend = XMLHttpRequest.prototype.send;

	XMLHttpRequest.prototype.open = function ( method, url, ...rest ) {
		this._isSameOrigin = new URL( url, window.location.origin ).origin === window.location.origin;
		originalOpen.apply( this, [ method, url, ...rest ] );
	};

	XMLHttpRequest.prototype.send = function ( ...args ) {
		const customHeaders = getCustomHeaders();

		if ( this._isSameOrigin ) {
			console.log( 'Adding custom headers to XMLHttpRequest call', customHeaders );
			for ( const [ header, value ] of Object.entries( customHeaders ) ) {
				this.setRequestHeader( header, value );
			}
		}
		originalSend.apply( this, args );
	};
}
